/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RelatedFile
 */
export interface RelatedFile {
    /**
     * 
     * @type {string}
     * @memberof RelatedFile
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedFile
     */
    description?: string;
}

/**
 * Check if a given object implements the RelatedFile interface.
 */
export function instanceOfRelatedFile(value: object): value is RelatedFile {
    return true;
}

export function RelatedFileFromJSON(json: any): RelatedFile {
    return RelatedFileFromJSONTyped(json, false);
}

export function RelatedFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelatedFile {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function RelatedFileToJSON(json: any): RelatedFile {
    return RelatedFileToJSONTyped(json, false);
}

export function RelatedFileToJSONTyped(value?: RelatedFile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
        'description': value['description'],
    };
}

